import type { BdState } from './state.model';

export class BdStateStore {
  public static byId(stateId: number): BdState {
    const result = BD_STATES.filter((state) => state.id === stateId);

    return result[0] ? result[0] : null;
  }
}

export const BD_STATES_REAL: BdState[] = [
  { id: 8, name: 'Baden-Württemberg' },
  { id: 9, name: 'Bayern' },
  { id: 11, name: 'Berlin' },
  { id: 12, name: 'Brandenburg' },
  { id: 4, name: 'Bremen' },
  { id: 2, name: 'Hamburg' },
  { id: 6, name: 'Hessen' },
  { id: 13, name: 'Mecklenburg-Vorpommern' },
  { id: 3, name: 'Niedersachsen' },
  { id: 5, name: 'Nordrhein-Westfalen' },
  { id: 7, name: 'Rheinland-Pfalz' },
  { id: 10, name: 'Saarland' },
  { id: 14, name: 'Sachsen' },
  { id: 15, name: 'Sachsen-Anhalt' },
  { id: 1, name: 'Schleswig-Holstein' },
  { id: 16, name: 'Thüringen' },
];

export const BD_STATES: BdState[] = [
  { id: -1, name: 'Bund' },
  ...BD_STATES_REAL,
];
